import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-gray-200 bg-white py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-75" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-76" data-mp="9t1lx2h7259f">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-gray-200 bg-pearl p-8 sm:p-12" data-id="element-77" data-mp="etpnuj6yo6if">
          <span className="inline-flex rounded-full bg-aqua-soft p-4 text-aqua" data-id="element-78" data-mp="sm5hwuhvwu77">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-79" data-mp="xk72xkyvf3lb" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-bold tracking-tight text-navy sm:text-4xl" data-id="element-80" data-mp="12jjxkrvzheyg">
            7-Day <span className="text-aqua" data-id="element-81" data-mp="17j6dj93759ay">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-gray-600" data-id="element-82" data-mp="25rnjv1wi2quc">
            Study all 6 volumes and 5 bonuses this week. If the technical depth doesn&apos;t match your professional
            needs,{' '}
            <span className="font-semibold text-navy" data-id="element-83" data-mp="1vt7qstdwx7i7">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}